import React from "react";
import { createUseStyles } from "react-jss";
import { Prompt } from "../../Prompt";
import { Tooltip } from "../../Tooltip";
import { v4 as uuidv4 } from "uuid";
import { isArrayDefined } from "../../utils/isDefined";
import { useTranslation } from "../../hooks/useTranslation";
export var InlineFeedback = function (props) {
    var t = useTranslation();
    var classes = useInlineFeedbackClasses();
    var message = props.message, shortMessage = props.shortMessage, type = props.type;
    if (message) {
        return (React.createElement(Tooltip, { tooltipId: uuidv4(), content: message, iconShown: false },
            React.createElement(Prompt, { type: type !== null && type !== void 0 ? type : "warning", message: shortMessage !== null && shortMessage !== void 0 ? shortMessage : t("Issue"), className: classes.prompt })));
    }
    return (React.createElement(Prompt, { type: type !== null && type !== void 0 ? type : "warning", message: shortMessage !== null && shortMessage !== void 0 ? shortMessage : t("Issue"), className: classes.prompt }));
};
export var useInlineFeedbackClasses = function () {
    var useStyles = createUseStyles({
        prompt: {
            marginLeft: 4,
        },
    });
    return useStyles();
};
export function getInlineFeedback(feedback, rowKey, item, column) {
    if (column &&
        feedback &&
        isArrayDefined(feedback) &&
        rowKey &&
        typeof rowKey === "string") {
        var rowFeedback = feedback.filter(function (feedbackItem) {
            return (item === null || item === void 0 ? void 0 : item.id) === feedbackItem.dataKey &&
                feedbackItem.columnKey === (column === null || column === void 0 ? void 0 : column.key);
        })[0];
        return rowFeedback;
    }
    return undefined;
}
export function drawersToOpenIfFeedback(feedback, rowKey, data) {
    var listOfIds = [];
    if (feedback && isArrayDefined(feedback) && data && isArrayDefined(data)) {
        feedback === null || feedback === void 0 ? void 0 : feedback.forEach(function (item) {
            data === null || data === void 0 ? void 0 : data.forEach(function (row) {
                if (rowKey && row[rowKey] === item.dataKey)
                    listOfIds.push(item.dataKey);
            });
        });
    }
    return listOfIds;
}
